<template>
    <div class="container-fluid" v-if="tracker && posicao">

        <header-admin :rastreador="tracker" :posicao="posicao" :veiculo="veiculo"></header-admin>

        <vue-tabs :keep-alive="true">

            <v-tab title="INICIAL">
                <br/>
                <positions-maps :posicao="posicao"/>
            </v-tab>

            <v-tab title="COMANDOS">

                <br/>

                <div class="col-sm-3">
                    <solicitar-configuracao :id_rastreador="rastreador.id_rastreador"/><br/>
                    <solicitar-posicao :id_rastreador="rastreador.id_rastreador"/>
                </div>

                <div class="col-sm-9">
                    <table-comandos :id_rastreador="rastreador.id_rastreador"/>
                </div>

            </v-tab>

            <v-tab title="PROBLEMAS" v-if="veiculo && ! isMobile">
                <br/>
                <problemas  @reload="loadVeiculo($event)" :veiculo="veiculo"></problemas>
            </v-tab>

            <v-tab title="CLIENTE" v-if="cliente">
                <div class="row">
                    <form-cliente :cliente="cliente"  :edit="false" :showFinanceiro="false"/>
                </div>
                <div class="row">
                    <table-telefones-clientes :height="null" :telefones="cliente.telefones" :edit="false"></table-telefones-clientes>
                </div>
            </v-tab>

            <v-tab title="OBS" v-if="veiculo">
                <br/>
                <label for="hora_inicial_noturno" class="col-sm-6 control-label">OBS DO VEÍCULO:</label>
                <textarea v-model="veiculo.obs" style="height: 200px !important;" class="form-control"></textarea>
            </v-tab>

            <v-tab title="HISTÓRICO">
                <br/>
                <relatorio-periodo :id_rastreador="rastreador.id_rastreador"/>
            </v-tab>

            <v-tab title="ALERTAS" v-if="veiculo">
                <br/>
                <relatorio-alertas :uuid="veiculo.uuid"/>
            </v-tab>

            <v-tab title="RELATÓRIOS" v-if="veiculo && ! isMobile" >
                <br/>
                <relatorios :uuid="veiculo.uuid" :id_cliente="veiculo.id_cliente"></relatorios>
            </v-tab>

            <v-tab title="CONFIGURAÇÃO" v-if="config">
                <br/>
                <div v-if="config" style="margin-bottom: 10px">IMEI DO CHIP: <b>{{config.imei}}</b></div>
                <vue-tabs>
                    <v-tab title="CONEXAO" v-if="config">
                        <br/>
                        <conexao :config="config"/>
                    </v-tab>
                </vue-tabs>
            </v-tab>

        </vue-tabs>

    </div>
    <div class="container-fluid" v-else>
        <center>
            <h1>Aguardando dados e primeira transmissão</h1>
        </center>
        <vue-tabs :keep-alive="true">

            <v-tab title="INICIAL">
                <br/>
                <positions-maps :posicao="posicao"/>
            </v-tab>

            <v-tab title="COMANDOS">

                <br/>

                <div class="col-sm-3">
                    <solicitar-configuracao :id_rastreador="rastreador.id_rastreador"/><br/>
                    <solicitar-posicao :id_rastreador="rastreador.id_rastreador"/>
                </div>

                <div class="col-sm-9">
                    <table-comandos :id_rastreador="rastreador.id_rastreador"/>
                </div>

            </v-tab>
        </vue-tabs>
    </div>
</template>
<script>
    import {Rastreador, Suntech, Veiculo} from "../../class";
    import HeaderAdmin from './HeaderAdmin';
    import RelatorioPeriodo from '../../components/relatorios/RelatorioPeriodo';
    import EnviarSaidas from '../../components/buttons/EnviarSaidas';
    import SolicitarConfiguracao from '../../components/buttons/SolicitarConfiguracao.vue';
    import SolicitarPosicao from '../../components/buttons/SolicitarPosicao.vue';
    import Conexao from './partials/suntech/Conexao.vue';
    import Relatorios from '../../components/veiculo/Relatorios';
    import MapComponent from '../maps/MapComponent';
    import AjustarHorimetro from "./partials/AjustarHorimetro.vue";
    import RelatorioAlertas from "../relatorios/RelatorioAlertas";
    import Problemas from "../veiculo/Problemas";
    import TableComandos from "../tables/TableComandos";
    import Reset from "../buttons/Reset";
    import FormCliente from '../forms/FormCliente';
    import TableTelefonesClientes from '../tables/TableTelefonesClientes';
    import {veiculosAdminMixins} from './partials/veiculo-admin-mixins';
    import PositionsMaps from './partials/PositionsMaps.vue';
    import {isMobile} from 'mobile-device-detect';

    export default {

        name: 'Suntech410',
        methods: {
            isMobile() {
                return isMobile
            }
        },

        components: {
            PositionsMaps,
            TableTelefonesClientes,
            FormCliente,
            Problemas,
            RelatorioAlertas,
            AjustarHorimetro,
            MapComponent,
            HeaderAdmin, RelatorioPeriodo,
            Reset, TableComandos, Relatorios,
            SolicitarConfiguracao, Conexao, EnviarSaidas,
            SolicitarPosicao
        },

        data(){
            return {
                config: null,
            }
        },

        mixins: [
            veiculosAdminMixins
        ],

        async beforeMount(){
            this.config = await Suntech.byPK(this.rastreador.id_rastreador);
        },

    }
</script>
